import { Button, Card, CardFooter } from "@rumbledirect/ui";
import type { EmailSent } from "@rumble-it/common-lib/types/models/EmailSent.interface";
import type { Dispatch, SetStateAction } from "react";
import { Modal } from "@/components/v2";

interface ModalEmailCorrespondenceProps {
  emailDetails: EmailSent | null | undefined;
  title: string;
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
}

export const ModalEmailCorrespondence = ({
  emailDetails,
  title,
  isOpen,
  setIsOpen,
  loading = false,
}: ModalEmailCorrespondenceProps) => {
  const { from, to, cc, bcc, replyTo, subject, html, messageId } =
    emailDetails || {};

  const renderList = (label: string, list: string[] | null | undefined) => {
    if (!list || !list.length) return null;
    return (
      <span>
        <strong>{label}:</strong> {list.join(", ")}
      </span>
    );
  };

  return (
    <Modal
      loading={loading}
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      width="80%"
    >
      <Card title={title}>
        <div className="flex flex-col gap-4 w-full">
          <div className="mb-8 space-y-2 flex flex-col gap-1">
            {renderList("Van", from)}
            {renderList("Aan", to)}
            {renderList("Cc", cc)}
            {renderList("Bcc", bcc)}
            {renderList("Antwoord naar", replyTo)}

            {/* TODO: Implement Date */}
            {/* {date ? (
              <p>
                <strong>Datum:</strong> {date}
              </p>
            ) : null} */}

            <p>
              <strong>Onderwerp:</strong> {subject}
            </p>
          </div>

          <div
            className="border border-gray-200 rounded mb-4"
            dangerouslySetInnerHTML={{ __html: html ?? "" }}
          />

          {messageId ? (
            <p>
              <strong>Bericht ID:</strong> {messageId}
            </p>
          ) : null}
        </div>

        <CardFooter>
          <Button onClick={() => setIsOpen(false)}>Sluiten</Button>
        </CardFooter>
      </Card>
    </Modal>
  );
};

export default ModalEmailCorrespondence;
